(function () {
  const STORAGE_KEY = 'glamp-review-campaign-product';

  function initCampaign(root) {
    const heroVideo = root.querySelector('[data-grc-hero-video]');
    const sectionNav = root.querySelector('[data-grc-section-nav]');
    const selectedBox = root.querySelector('[data-grc-selected-product]');
    const selectedName = root.querySelector('[data-grc-selected-product-name]');
    const choiceLinks = root.querySelectorAll('[data-grc-product-choice]');

    if (heroVideo && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      heroVideo.pause();
      heroVideo.removeAttribute('autoplay');
    }

    if (sectionNav) {
      const stickyHeader = document.querySelector('.header_bottom.header__sticky');
      const syncStickyOffset = function () {
        const headerHeight = stickyHeader ? Math.round(stickyHeader.getBoundingClientRect().height) : 0;
        root.style.setProperty('--grc-sticky-offset', headerHeight + 'px');
      };

      syncStickyOffset();
      window.requestAnimationFrame(syncStickyOffset);
      window.addEventListener('resize', syncStickyOffset, { passive: true });

      if (stickyHeader && 'ResizeObserver' in window) {
        const headerResizeObserver = new ResizeObserver(syncStickyOffset);
        headerResizeObserver.observe(stickyHeader);
      }
    }

    function showSelected(productName) {
      if (!selectedBox || !selectedName || !productName) return;
      selectedName.textContent = productName;
      selectedBox.hidden = false;
    }

    try {
      showSelected(window.sessionStorage.getItem(STORAGE_KEY));
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; the links still work.
    }

    choiceLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        const productName = link.getAttribute('data-grc-product-choice');
        showSelected(productName);
        try {
          window.sessionStorage.setItem(STORAGE_KEY, productName);
        } catch (error) {
          // Do not block review navigation if storage is unavailable.
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-glamp-review-campaign]').forEach(initCampaign);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
